<template>
  <div id="app">
    <RouterView />

    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          Copyright © {{ new Date().getFullYear() }} STAJets
        </p>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

#app {
  flex: 1;
  display: flex;
  flex-direction: column;
}

footer {
  margin-top: auto;
}
</style>